import React from 'react';
import { Tabs } from 'antd';
/**
 * * 작품 속 메뉴 & 유저 관리 상세 내용 탭
 */

interface IProps {
  activeKey?: string;
  onChange?: (e: string) => void;
  type?: 'line' | 'card' | 'editable-card';
  children?: JSX.Element[] | JSX.Element;
}
const DefaultTabs: React.FC<IProps> = ({
  activeKey,
  onChange,
  type,
  children,
}) => {
  return (
    <Tabs activeKey={activeKey} onChange={onChange} type={type}>
      {children}
    </Tabs>
  );
};

export default DefaultTabs;
